import { useQuery } from "react-query";
import { getTeacherByUserId } from "../services/school/teacher/getTeachers";
import { key_userId } from "../utils/constants";

export const useGetTeacheIdByUserId = (id:string, options:any= null) =>
  useQuery(
    [key_userId, id],
    () => getTeacherByUserId(id), 
    options?{...options}:{}
  );